import api from '@/api/api'
import router from '@/router/index'
import { schema } from 'normalizr'

export const provincia = new schema.Entity('provincia')

export default {
  namespaced: true,
  state: {
    list: {}
  },
  mutations: {
    setAll (state, payload) {
      state.list = Object.assign({}, payload)
    },
    updateSet (state, payload) {
      state.list = Object.assign({}, state.list, payload)
    }
  },
  actions: {
    loadProvincias ({ dispatch }, codigoPais) { // Devuelve todas las promociones
      return new Promise((resolve, reject) => {
        api.get('/maestros/get_provincias', {
          params: {
            jsondata: JSON.stringify({
              parametros: {
                codigoPais
              }
            })
          }
        })
          .then(response => {
            if (response.data.result.ok) {
              resolve(response.data.result.data.data)
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    }
  },
  getters: {
    getAll (state) {
      return Object.keys(state.list).map(id => state.list[id]).sort((x, y) => x.denominacionProvincia.localeCompare(y.denominacionProvincia))
    },
    getById (state) {
      return id => state.list[id]
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/maestros/provincias/store.js